import { Pipe, PipeTransform } from '@angular/core';
import { NextEvent } from '@fantaz/shared/data-access/models';

@Pipe({
  name: 'fzSeatsResume',
  standalone: true,
  pure: true,
})
export class SeatsResumePipe implements PipeTransform {
  transform(toPlayNow: NextEvent | null | undefined): string {
    if (!toPlayNow) {
      return '';
    }
    if (toPlayNow?.availableSeats == toPlayNow?.seats) {
      return 'All seats available';
    }

    return `${toPlayNow.availableSeats} available seat(${toPlayNow.participants?.length}/${toPlayNow.seats})`;
  }
}
